import lodashOmit from 'lodash/fp/omit';

const withoutId = lodashOmit('id');

export default withoutId;
